module.exports = __webpack_public_path__ + "images/ideal.b6a01ec67aaf4be5b0b0cc4e6c0475d0.png";